<template>
    <div class="task-detail-right-side" :class="{ 'task-detail-inline-info': inlineLayout }">
        <div class="task-detail-info-fields">
            <h4 class="details-heading">{{ $t("ProjectDetails.details") }}</h4>
            <div class="task-detail-info-split">
                <div class="task-detail-info-left">
            <div
                class="d-flex task-detail-right-side-label task-detail-primary-field"
                v-if="
                    checkPermission('task.task_list', project?.isGlobalPermission) !== null &&
                    checkPermission('task.task_status', project?.isGlobalPermission) !== null
                "
            >
                <h4>
                    <img :src="fieldIcons.status" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("ProjectDetails.status") }}</span>
                </h4>
                <TaskStatus
                    :task-key="task.statusKey"
                    :sprintId="task.sprintId"
                    :taskId="task._id"
                    :projectId="task.ProjectID"
                    @update:status="
                        (oldVal, newVal) => {
                            updateStatus(oldVal, newVal);
                        }
                    "
                    class="d-flex taskdetail-label task-detail-right-wrapper"
                    :taskStatusIndex="props.taskStatusIndex"
                    :disabled="isTaskCompleted || !canEditKpiTask"
                />
                <div v-if="task.statusType === 'done' && task.isKpi && isFieldWaiting('status')" class="kpi-review-actions">
                    <span class="notify-manager-note">{{ $t("Kpi.waiting") }}</span>
                    <button
                        v-if="isFieldWaiting('status') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-green kpi-review-button"
                        @click="handleChangeRequest({ field: 'status', action: 'approve' })"
                    >
                        {{ $t("Kpi.confirm") }}
                    </button>

                    <button
                        v-if="isFieldWaiting('status') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-red kpi-review-button"
                        @click="handleChangeRequest({ field: 'status', action: 'reject' })"
                    >
                        {{ $t("Kpi.reject") }}
                    </button>
                </div>
            </div>
            <div class="d-flex task-detail-right-side-label task-detail-primary-field" v-if="!isPersonalProject && checkPermission('task.task_assignee', project?.isGlobalPermission) !== null">
                <h4>
                    <img :src="fieldIcons.assignee" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("ProjectDetails.assignee") }}</span>
                </h4>
                <Assignee
                    v-if="
                        checkPermission('task.task_assignee', project?.isGlobalPermission) === true &&
                        checkPermission('task.task_list', project?.isGlobalPermission) == true
                    "
                    class="taskdetail-label task-detail-right-wrapper ml-5px"
                    :numOfUsers="2"
                    :users="displayAssignee"
                    :addUser="checkPermission('task.task_assignee', project?.isGlobalPermission) === true"
                    :options="permittedOptions"
                    @selected="updateAssignee($event, checkApps('MultipleAssignees', project) ? 'add' : 'replace')"
                    @removed="updateAssignee($event, 'remove')"
                    imageWidth="30px"
                    :showAddUser="true"
                    :zIndexAssigne="props.zIndexAssigne"
                    :isDisplayTeam="true"
                    :multiSelect="checkApps('MultipleAssignees')"
                    :disabled="isTaskCompleted || !canEditKpiTask"
                />
                <Assignee
                    v-else
                    class="taskdetail-label task-detail-right-wrapper ml-5px"
                    :numOfUsers="2"
                    :showAddUser="true"
                    @selected="updateAssignee($event, checkApps('MultipleAssignees', project) ? 'add' : 'replace')"
                    @removed="updateAssignee($event, 'remove')"
                    :users="task.AssigneeUserId"
                    :options="nonPermittedOptions"
                    imageWidth="30px"
                    :zIndexAssigne="props.zIndexAssigne"
                    :isDisplayTeam="true"
                    :multiSelect="checkApps('MultipleAssignees')"
                    :disabled="isTaskCompleted || !canEditKpiTask"
                />
            </div>
            <div v-if="isKpiEnabled" class="d-flex task-detail-primary-field task-detail-field-action-row">
                <div class="task-detail-right-wrapper kpi-review-actions justify-content-end">
                    <span v-if="isFieldWaiting('assignee')" class="kpi-badge-waiting"> {{ $t("Kpi.waiting") }} </span>

                    <!-- <span v-if="getLatestRequest('assignee')?.status === 1" class="kpi-badge-confirmed"> Confirmed </span> -->

                    <button
                        v-if="isFieldWaiting('assignee') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-green kpi-review-button"
                        @click="handleChangeRequest({ field: 'assignee', action: 'approve' })"
                    >
                        {{ $t("Kpi.confirm") }}
                    </button>

                    <button
                        v-if="isFieldWaiting('assignee') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-red kpi-review-button"
                        @click="handleChangeRequest({ field: 'assignee', action: 'reject' })"
                    >
                        {{ $t("Kpi.reject") }}
                    </button>
                </div>
            </div>
            <div class="d-flex task-detail-right-side-label task-detail-primary-field">
                <h4>
                    <img :src="fieldIcons.reporter" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("ProjectDetails.reporter") }}</span>
                </h4>
                <div class="d-flex align-items-center task-detail-right-wrapper">
                    <UserProfile
                        :data="{
                            image: taskLeaderData.Employee_profileImageURL,
                            title: taskLeaderData.Employee_Name,
                        }"
                        :showDot="false"
                        width="30px"
                        :thumbnail="'30x30'"
                    />
                </div>
            </div>

            <div class="d-flex task-detail-right-side-label task-detail-primary-field">
                <h4>
                    <img :src="fieldIcons.approval" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("Kpi.approval") }}</span>
                </h4>
                <div class="d-flex align-items-center task-detail-right-wrapper">
                    <UserProfile
                        v-if="approvalUser"
                        :data="{
                            image: approvalUser.Employee_profileImageURL,
                            title: approvalUser.Employee_Name,
                        }"
                        :showDot="false"
                        width="30px"
                        :thumbnail="'30x30'"
                    />
                    <span v-else class="kpi-missing-hint">{{ $t("Kpi.no_approval") }}</span>
                </div>
            </div>
            <div
                class="d-flex task-detail-right-side-label task-detail-primary-field"
                v-if="checkPermission('task.task_priority', project?.isGlobalPermission) !== null && checkApps('Priority')"
            >
                <h4>
                    <img :src="fieldIcons.priority" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("Projects.priority") }}</span>
                </h4>
                <PriorityComp
                    :priorityVal="task.Task_Priority"
                    :showName="true"
                    @select="updatePriority($event)"
                    class="priority-comp taskdetail-label task-detail-right-wrapper ml-0"
                    :zIndexPriority="props.zIndexPriority"
                    :permission="checkPermission('task.task_priority', project?.isGlobalPermission) === true"
                    :disable="isTaskCompleted || !canEditKpiTask"
                />
            </div>
            <div
                class="d-flex task-detail-right-side-label task-detail-primary-field"
                v-if="isSupport === false && checkPermission('task.task_start_date', project?.isGlobalPermission) !== null"
            >
                <h4>
                    <img :src="fieldIcons.date" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("Milestone.start_date") }}</span>
                </h4>
                <div
                    class="w-full d-flex align-items-center"
                    v-if="
                        checkPermission('task.task_list', project?.isGlobalPermission) == true &&
                        checkPermission('task.task_start_date', project?.isGlobalPermission) === true
                    "
                >
                    <DueDateCompo
                        id="due-date-task"
                        :key="startDateKey"
                        class="taskdetail-label task-detail-right-wrapper"
                        :class="{ 'pointer-block': isTaskCompleted || !canEditKpiTask }"
                        :displyDate="displayStartDate"
                        :isShowDateAndicon="true"
                        @SelectedDate="($event) => updateStartDate($event)"
                        :position="`right`"
                        :disable="isTaskCompleted || !canEditKpiTask"
                    />
                    <div v-if="oldStartDate" class="old-date-text">{{ $t("Kpi.old") }}: {{ convertDateFormat(oldStartDate, "", { showDayName: false }) }}</div>
                </div>
                <template v-else>
                    <span v-if="task.startDate">{{ convertDateFormat(task.startDate, "", { showDayName: false }) }}</span>
                    <span v-else>{{ $t("ProjectDetails.no_start_date") }}</span>
                </template>
            </div>
            <div v-if="isKpiEnabled && getLatestRequest('start_date')?.status != 1" class="d-flex task-detail-primary-field task-detail-field-action-row">
                <div class="task-detail-right-wrapper kpi-review-actions justify-content-end">
                    <span v-if="isFieldWaiting('start_date')" class="kpi-badge-waiting"> {{ $t("Kpi.waiting") }} </span>

                    <span v-if="getLatestRequest('start_date')?.status === 1" class="kpi-badge-confirmed"> {{ $t("Kpi.confirmed") }} </span>

                    <button
                        v-if="isFieldWaiting('start_date') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-green kpi-review-button"
                        @click="handleChangeRequest({ field: 'start_date', action: 'approve' })"
                    >
                        {{ $t("Kpi.confirm") }}
                    </button>

                    <button
                        v-if="isFieldWaiting('start_date') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-red kpi-review-button"
                        @click="handleChangeRequest({ field: 'start_date', action: 'reject' })"
                    >
                        {{ $t("Kpi.reject") }}
                    </button>
                </div>
            </div>
            <div class="d-flex task-detail-right-side-label task-detail-primary-field" v-if="checkPermission('task.task_due_date', project?.isGlobalPermission) !== null">
                <h4>
                    <img :src="fieldIcons.date" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("Projects.due_date") }}</span>
                </h4>
                <div
                    class="w-full d-flex align-items-center"
                    v-if="
                        checkPermission('task.task_due_date', project?.isGlobalPermission) === true &&
                        checkPermission('task.task_list', project?.isGlobalPermission) == true
                    "
                >
                    <DueDateCompo
                        id="due-date-task"
                        :key="dueDateKey"
                        class="taskdetail-label task-detail-right-wrapper"
                        :displyDate="displayDueDate"
                        :isShowDateAndicon="true"
                        :disabledDates="task.dueDateDeadLine"
                        @SelectedDate="($event) => updateDueDate($event)"
                        :position="`right`"
                        :disable="isTaskCompleted || !canEditKpiTask"
                    />
                    <div v-if="oldDueDate" class="old-date-text">{{ $t("Kpi.old") }}: {{ convertDateFormat(oldDueDate, "", { showDayName: false }) }}</div>
                </div>
                <template v-else>
                    <span v-if="task.DueDate">{{ convertDateFormat(task.DueDate, "", { showDayName: false }) }}</span>
                    <span v-else>{{ $t("ProjectDetails.no_due_date") }}</span>
                </template>
            </div>
            <div v-if="isKpiEnabled && !isDueDateApproved" class="d-flex task-detail-primary-field task-detail-field-action-row">
                <div class="task-detail-right-wrapper kpi-review-actions justify-content-end">
                    <span v-if="isFieldWaiting('due_date')" class="kpi-badge-waiting"> {{ $t("Kpi.waiting") }} </span>

                    <span v-if="isDueDateApproved" class="kpi-badge-confirmed"> {{ $t("Kpi.confirmed") }} </span>
                    <button
                        v-if="isFieldWaiting('due_date') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-green kpi-review-button"
                        @click="handleChangeRequest({ field: 'due_date', action: 'approve' })"
                    >
                        {{ $t("Kpi.confirm") }}
                    </button>
                    <button
                        v-if="isFieldWaiting('due_date') && _getRole() === 'manager' && isCurrentApprovalUser"
                        class="outline-red kpi-review-button"
                        @click="handleChangeRequest({ field: 'due_date', action: 'reject' })"
                    >
                        {{ $t("Kpi.reject") }}
                    </button>
                </div>
            </div>
                </div>
                <div class="task-detail-info-right">
            <div
                class="d-flex task-detail-right-side-label"
                v-if="checkApps('TimeEstimates') && checkPermission('task.task_estimated_hours', project?.isGlobalPermission) !== null"
            >
                <h4>
                    <img :src="fieldIcons.estimated" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("UserTimesheet.estimated") }}</span>
                </h4>
                <div class="w-full">
                    <EstimateHours
                        v-if="Object.keys(task || {}).length"
                        :permission="checkPermission('task.task_estimated_hours', project?.isGlobalPermission)"
                        :task="task"
                        class="d-flex taskdetail-label"
                        @update:dueDate="($event) => updateDueDate($event)"
                        @update:startDate="($event) => updateStartDate($event)"
                        :zIndexEstimate="props.zIndexEstimate"
                        :isSpinner="isSpinner"
                    />
                </div>
            </div>
            <div v-if="showKpiToggle" class="task-detail-divider task-detail-kpi-field"></div>
            <div class="d-flex task-detail-right-side-label task-detail-kpi-field task-detail-kpi-row" v-if="showKpiToggle">
                <h4>
                    <img :src="fieldIcons.kpi" class="task-detail-field-icon" alt="" />
                    <span>{{ $t("Kpi.kpi") }}</span>
                </h4>
                <div class="d-flex task-detail-right-wrapper task-detail-kpi-control">
                    <Toggle
                        v-model="isKpiEnabled"
                        :width="36"
                        :disabled="kpiToggleDisabled || isTaskCompleted || !canToggleKpi"
                        :activeColor="kpiToggleColor"
                        @update:modelValue="handleKpiToggle"
                    />

                    <div class="d-flex task-detail-kpi-status">
                        <div class="task-detail-right-wrapper kpi-review-actions">
                        <span v-if="kpiWaiting" class="kpi-badge-waiting"> {{ $t("Kpi.waiting") }} </span>
                        <span v-if="kpiConfirmed" class="kpi-badge-confirmed"> {{ $t("Kpi.confirmed") }} </span>
                        <button v-if="kpiWaiting && _getRole() === 'manager' && isCurrentApprovalUser" class="outline-green kpi-review-button" @click="confirmKpi">
                        {{ $t("Kpi.confirm") }}
                    </button>
                        <button v-if="kpiWaiting && _getRole() === 'manager' && isCurrentApprovalUser" class="outline-red kpi-review-button" @click="rejectKpi">
                        {{ $t("Kpi.reject") }}
                    </button>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="kpiErrors.length" class="kpi-errors-wrapper task-detail-kpi-field">
                <div v-for="(error, idx) in kpiErrors" :key="idx" class="kpi-error-item">
                    {{ error }}
                </div>
            </div>
        <div v-if="showScoringResults" class="kpi-scoring-results task-detail-kpi-field">
            <div class="kpi-scoring-divider"></div>
            <h4 class="kpi-scoring-heading">{{ $t("Kpi.scoring_results") }}</h4>

            <!-- Time Score -->
            <div class="kpi-scoring-row">
                <div class="kpi-scoring-label">
                    <span>{{ $t("Kpi.time_score") }}</span>
                    <span class="kpi-scoring-value">{{ scoringDisplay.timeScore }}/45</span>
                </div>
                <div class="kpi-scoring-bar">
                    <div class="kpi-scoring-time-background kpi-scoring-bar-fill" :style="{ width: scoringDisplay.timeBarPercent + '%' }"></div>
                </div>
            </div>

            <!-- Quality Score -->
            <div class="kpi-scoring-row">
                <div class="kpi-scoring-label">
                    <span>{{ $t("Kpi.quality_score") }}</span>
                    <span class="kpi-scoring-value">{{ scoringDisplay.qualityScore }}/45</span>
                </div>
                <div class="kpi-scoring-bar">
                    <div class="kpi-scoring-quality-background kpi-scoring-bar-fill" :style="{ width: scoringDisplay.qualityBarPercent + '%' }"></div>
                </div>
            </div>

            <!-- Bonus -->
            <div class="kpi-scoring-row">
                <div class="kpi-scoring-label">
                    <span>{{ $t("Kpi.bonus") }}</span>
                    <span class="bonus-color kpi-scoring-value">+{{ scoringDisplay.bonus }}</span>
                </div>
                <div class="kpi-scoring-bar">
                    <div class="bonus-background-color kpi-scoring-bar-fill" :style="{ width: scoringDisplay.bonusBarPercent + '%' }"></div>
                </div>
            </div>

            <!-- Total Score -->
            <div class="kpi-scoring-row kpi-scoring-total">
                <h5 class="kpi-scoring-total-title">{{ $t("Kpi.total_score") }}</h5>
                <div class="kpi-scoring-total-head">
                    <span class="kpi-scoring-total-value" :class="totalScoreColorClass">{{ scoringDisplay.totalScore }}/100</span>
                    <span class="kpi-scoring-grade" :class="totalScoreColorClass">{{ totalScoreGrade }}</span>
                </div>
                <div class="kpi-scoring-total-scale">
                <div class="kpi-scoring-total-range kpi-scoring-total-range--low"></div>
                <div class="kpi-scoring-total-range kpi-scoring-total-range--mid"></div>
                <div class="kpi-scoring-total-range kpi-scoring-total-range--good"></div>

                <span
                    class="kpi-scoring-total-marker"
                    :style="{ left: totalScorePercent + '%' }"
                ></span>
                </div>
                <div class="kpi-scoring-scale-labels">
                    <span style="left:2%">0</span>
                    <span style="left:25%">25</span>
                    <span style="left:50%">50</span>
                    <span style="left:75%">75</span>
                    <span style="left:98%">100</span>
                </div>
            </div>

            <!-- Comment -->
            <div v-if="hasScoringComment" class="kpi-scoring-comment">
                <h5 class="kpi-scoring-comment-title">{{ $t("Comments.comment") }}</h5>
                <div class="kpi-scoring-comment-box">
                    {{ scoringDisplay.comment }}
                </div>
            </div>
            <div v-if="scoringUpdatedText" class="kpi-scoring-updated">{{ scoringUpdatedText }}</div>
        </div>

        <div class="kpi-date-requests-section task-detail-kpi-field">
            <div v-for="req in pendingDateRequests" :key="req._id" class="d-flex task-detail-right-side-label kpi-date-request-row">
                <h4></h4>
                <div class="task-detail-right-wrapper">
                    <div class="kpi-date-request-card">
                        <div class="kpi-date-request-info">
                            <span class="kpi-date-request-field">
                                {{ req.field === "DueDate" ? $t("Projects.due_date") : $t("Milestone.start_date") }}
                            </span>
                            <span class="kpi-date-request-values">
                                {{ formatDate(req.oldValue) }} → <b>{{ formatDate(req.newValue) }}</b>
                            </span>
                            <span class="kpi-badge-waiting kpi-date-request-badge">{{ $t("Kpi.pending") }}</span>
                        </div>

                        <div v-if="_getRole() === 'manager' && isCurrentApprovalUser" class="kpi-date-request-actions">
                            <button class="outline-primary" :disabled="dateReqLoading === req._id" @click="confirmDateChange(req)">✓</button>
                            <button class="outline-secondary" :disabled="dateReqLoading === req._id" @click="rejectDateChange(req)">✕</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                </div>
            </div>
        </div>
    </div>

    <TaskScoringDialog :task="task" v-model="isShowTaskScoringDialog" @submit="onScoringSubmitted" />
</template>

<script setup>
import { computed, defineProps, inject, ref, watch } from "vue";
import { useStore } from "vuex";

import EstimateHours from "@/components/molecules/EstimateHours/EstimateHours.vue";
import TaskStatus from "@/components/molecules/TaskStatus/TaskStatus.vue";
import Assignee from "@/components/molecules/Assignee/Assignee.vue";
import UserProfile from "@/components/atom/UserProfile/UserProfile.vue";
import PriorityComp from "@/components/molecules/PriorityCompo/PriorityComp.vue";
import DueDateCompo from "@/components/molecules/DueDateCompo/DueDateCompo.vue";
import Toggle from "@/components/atom/Toggle/Toggle.vue";
import assigneeFieldIcon from "@/assets/images/svg/user_group.svg";
import approvalFieldIcon from "@/assets/images/svg/check_read_outline.svg";
import dateFieldIcon from "@/assets/images/svg/calendar.svg";
import estimatedFieldIcon from "@/assets/images/svg/hourglass_outline.svg";
import kpiFieldIcon from "@/assets/images/svg/diagram_up.svg";
import priorityFieldIcon from "@/assets/images/svg/priority_outline.svg";
import reporterFieldIcon from "@/assets/images/svg/User_icon.svg";
import statusFieldIcon from "@/assets/images/svg/notification_unread_outline.svg";

import { useConvertDate, useCustomComposable, useGetterFunctions, useMoment } from "@/composable";
import taskClass from "@/utils/TaskOperations";
import { taskDueDateAdd, taskDueDateChange } from "@/utils/NotificationTemplate";
import { useToast } from "vue-toast-notification";
import { useI18n } from "vue-i18n";
import { apiRequest } from "@/services";
import TaskScoringDialog from "../TaskScoringDialog/TaskScoringDialog.vue";
import * as env from "@/config/env";
import {
    canUserAccessKpiTask,
    canUserEditKpiTask,
    getApprovalIdForAssignee,
    getApprovalIdForTask,
    isSameId,
} from "@/utils/kpiTaskPermissions";
import { onMounted } from "vue";
import { useTaskChangeRequestSocket } from "@/composable/useTaskChangeRequestSocket";
const { t } = useI18n();
const fieldIcons = {
    status: statusFieldIcon,
    assignee: assigneeFieldIcon,
    reporter: reporterFieldIcon,
    approval: approvalFieldIcon,
    priority: priorityFieldIcon,
    date: dateFieldIcon,
    estimated: estimatedFieldIcon,
    kpi: kpiFieldIcon,
};

const { convertDateFormat } = useConvertDate();
const { getUser, getPriority } = useGetterFunctions();
const { checkPermission, checkApps, getWasabiImageLink } = useCustomComposable();
const { changeDateFormate } = useMoment();
const { getters } = useStore();

onMounted(() => {
    if (socket.value?.connected) {
        initTaskCR();
    } else {
        socket.value?.on("connect", () => {
            console.log("✅ socket connected → join room");
            initTaskCR();
        });
    }
});
const userId = inject("$userId");
const dateFormat = inject("$dateFormat");
const project = inject("selectedProject");
const store = useStore();
const $toast = useToast();
const props = defineProps({
    task: {
        type: Object,
        required: true,
    },
    parentTask: {
        type: Object,
        required: false,
    },
    taskStatusIndex: {
        type: Number,
        default: 7,
    },
    zIndexAssigne: {
        type: Number,
        default: 7,
    },
    zIndexPriority: {
        type: Number,
        default: 7,
    },
    zIndexEstimate: {
        type: Number,
        default: 7,
    },
    isSupport: {
        type: Boolean,
        default: false,
    },
    inlineLayout: {
        type: Boolean,
        default: false,
    },
});
const localDueDate = ref(props.task.DueDate || null);
const localStartDate = ref(props.task.startDate || null);
const socket = computed(() => getters["settings/getSocketInstance"] || null);

const { init: initTaskCR } = useTaskChangeRequestSocket({
    socket,
    taskId: props.task._id,
    store,
    getters,
});
const taskLeaderData = ref(getUser(props.task?.Task_Leader));
const assigneeInProgress = ref({});
const isSpinner = ref(false);
const totalScorePercent = computed(() => {
  const score = Number(kpiTotalScore.value || 0)
  return Math.min(98, Math.max(2, score))
})
watch(
    () => props.task,
    (val) => {
        taskLeaderData.value = getUser(val?.Task_Leader);
    },
);
watch(
    () => props.task?._id,
    (taskId) => {
        if (!taskId || !socket.value?.connected) return;

        console.log("🔥 re-init TCR socket", { taskId });

        initTaskCR();
    },
    { immediate: true }
);
const changeRequests = computed(() => getters["ChangeRequest/changeRequestsByTask"](props.task._id));
watch(changeRequests, (val) => {
    console.log("🔥 changeRequests changed:", val);
});
const isFieldWaiting = (field) => {
    return getLatestRequest(field)?.status === 0;
};
const getLatestRequest = (field) => {
    const list = Array.isArray(changeRequests.value) ? changeRequests.value : [];

    if (!list.length) return null;

    return list.filter((r) => r.field === field).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
};

const isDueDateApproved = computed(() => {
    return getLatestRequest("due_date")?.status === 1;
});
const displayDueDate = computed(() => {
    const latest = getLatestRequest("due_date");

    if (latest?.status === 0) return latest.newValue;

    return localDueDate.value;
});
const displayStartDate = computed(() => {
    const latest = getLatestRequest("start_date");

    if (latest?.status === 0) return latest.newValue;

    return localStartDate.value;
});
const oldStartDate = computed(() => {
    const latest = getLatestRequest("start_date");
    return latest?.status === 0 ? latest.oldValue : null;
});
const oldDueDate = computed(() => {
    const latest = getLatestRequest("due_date");
    return latest?.status === 0 ? latest.oldValue : null;
});
const displayAssignee = computed(() => {
    const latest = getLatestRequest("assignee");

    if (latest?.status === 0) {
        return Array.isArray(latest.newValue) ? latest.newValue : [latest.newValue];
    }

    return props.task.AssigneeUserId || [];
});
const isPersonalProject = computed(() => Boolean(project.value?.isPersonalProject));
const kpiPermissionMessage = computed(() => t("Kpi.only_assignee_or_approval_can_edit"));
const kpiApprovalMessage = computed(() => t("Kpi.no_approval"));
const canAccessKpiTask = computed(() => canUserAccessKpiTask(props.task, userId.value, companyUsers.value || []));
const canEditKpiTask = computed(() => {
    return canUserEditKpiTask(props.task, userId.value, companyUsers.value || []);
});
const canToggleKpi = computed(() => canAccessKpiTask.value);
const canReviewKpiTask = computed(() => _getRole() === "manager" && isCurrentApprovalUser.value);
const showKpiPermissionError = (message = kpiPermissionMessage.value, { silent = false } = {}) => {
    if (silent) return;
    $toast.error(message, { position: "top-right" });
};
watch(
    () => props.task,
    (val) => {
        localDueDate.value = val?.DueDate || null;
        localStartDate.value = val?.startDate || null;
    },
    { immediate: true, deep: true },
);
const kpiWaiting = computed(() => {
    return props.task.isKpi && (!props.task.kpiConfirmedAt || props.task.kpiStatus == null);
});

const kpiConfirmed = computed(() => {
    return props.task?.isKpi && !!props.task?.kpiConfirmedAt;
});
const companyOwner = computed(() => {
    return getters["settings/companyOwnerDetail"];
});

const handleChangeRequest = async ({
    field,
    action, // 'approve' | 'reject'
}) => {
    try {
        const request = changeRequests.value
            ?.filter((r) => r.field === field && r.status === 0)
            ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

        if (!request) {
            $toast.error(t("Kpi.request_not_found"));
            return;
        }

        const role = _getRole();
        if (role !== "manager") {
            $toast.error(t("Kpi.no_permission"));
            return;
        }

        if (!isCurrentApprovalUser.value) {
            $toast.error(t("Kpi.only_approver_can_review_request"));
            return;
        }

        if (action === "approve") {
            if (field === "assignee" && !getApprovalIdForAssignee(request.newValue, companyUsers.value || [])) {
                $toast.error(kpiApprovalMessage.value, { position: "top-right" });
                return;
            }

            await apiRequest("patch", env.TASK_CHANGE_REQUESTS + `/${request._id}`, {
                status: 1,
                approvedBy: userId.value,
                companyId: project.value.CompanyId,
            });
            await store.dispatch("ChangeRequest/fetchChangeRequests", {
                companyId: project.value.CompanyId,
                taskId: props.task._id,
            });
            // Status is already moved to Done while waiting for approval.
            // Other protected fields are only applied after approval.
            if (field !== "status") {
                await applyFieldUpdate(field, request.newValue);
            }

            $toast.success(t("Kpi.confirmed"));
        }

        if (action === "reject") {
            await apiRequest("patch", env.TASK_CHANGE_REQUESTS + `/${request._id}`, {
                status: 2, // rejected
                rejectedBy: userId.value,
                companyId: project.value.CompanyId,
            });
            await store.dispatch("ChangeRequest/fetchChangeRequests", {
                companyId: project.value.CompanyId,
                taskId: props.task._id,
            });
            if (field === "status" && request.oldValue) {
                await performStatusUpdate(request.newValue, request.oldValue);
            }
            $toast.success(t("Kpi.rejected"));
        }
    } catch (err) {
        console.error(err);
        $toast.error(t("Common.an_error_occurred"));
    }
};
const applyFieldUpdate = async (field, value) => {
    switch (field) {
        case "due_date":
            await updateDueDate({ dateVal: value }, { source: "approve" });
            break;

        case "start_date":
            await updateStartDate({ dateVal: value }, { source: "approve" });
            break;

        case "assignee":
            await updateAssignee({ id: value }, "replace", { source: "approve" });
            break;

        default:
            console.warn("Field chưa handle:", field);
    }
};
const companyUsers = computed(() => getters["settings/companyUsers"]);

const sprintData = computed(() => {
    let sprintData = false;
    if (project.value && props.task && Object.keys(props.task).length > 0) {
        sprintData = props.task.folderObjId
            ? project.value?.sprintsfolders?.[props.task?.folderObjId]?.sprintsObj?.[props.task?.sprintId]
            : project.value?.sprintsObj?.[props.task?.sprintId];
    }
    return sprintData || null;
});

function _getRole() {
    const currentUser = companyUsers.value?.find((u) =>
        [u?.userId, u?._id, u?.id, u?.requestId].some((id) => isSameId(id, userId.value)),
    );
    const roleType = currentUser?.roleType;
    if ([1, 2, 4].includes(Number(roleType))) {
        return "manager";
    }
    return "member";
}

const kpiLoading = ref(false);
const kpiErrors = ref([]);
const isKpiEnabled = ref(props.task?.isKpi || false);
const isShowTaskScoringDialog = ref(false);
const showScoringResults = ref(false);
const dueDateKey = ref(0);
const startDateKey = ref(0);

watch(
    () => props.task?.isKpi,
    (val) => {
        isKpiEnabled.value = val || false;
    },
);

const showKpiToggle = computed(() => {
    if (!props.task || !props.task._id) return false;
    if (props.task.deletedStatusKey !== 0) return false;
    if (props.task.isParentTask === false) return false;
    return true;
});

const kpiToggleDisabled = computed(() => {
    if (kpiLoading.value) return true;

    if (props.task.isKpiLocked) return true;

    if (props.task.isKpi && props.task.kpiConfirmedAt && _getRole() === "member") return true;

    return false;
});

const kpiToggleColor = computed(() => {
    return "#016CD7";
});

const kpiTimeScore = ref(0);
const kpiQualityScore = ref(0);
const kpiBonus = ref(0);
const kpiTotalScore = ref(0);
const comment = ref("");
const scoringUpdatedAt = ref(null);

const scoringDisplay = computed(() => {
    const timeScore = Number(kpiTimeScore.value || 0);
    const qualityScore = Number(kpiQualityScore.value || 0);
    const bonus = Number(kpiBonus.value || 0);
    const totalScore = Number(kpiTotalScore.value || 0);

    return {
        comment: comment.value,
        timeScore,
        qualityScore,
        bonus,
        totalScore,
        timeBarPercent: Math.min((timeScore / 45) * 100, 100),
        qualityBarPercent: Math.min((qualityScore / 45) * 100, 100),
        bonusBarPercent: Math.min((bonus / 10) * 100, 100),
    };
});

const totalScoreColorClass = computed(() => {
    const score = Number(kpiTotalScore.value || 0);

    if (score >= 80) return "kpi-total-green";
    if (score >= 60) return "kpi-total-yellow";
    return "kpi-total-red";
});
const totalScoreGrade = computed(() => {
    const score = Number(kpiTotalScore.value || 0);

    if (score >= 75) return t("Kpi.grade_good");
    if (score >= 35) return t("Kpi.grade_average");
    return t("Kpi.grade_low");
});
const scoringUpdatedText = computed(() => {
    if (!scoringUpdatedAt.value) return "";
    return t("Kpi.updated_at", { date: convertDateFormat(scoringUpdatedAt.value, "", { showDayName: false }) });
});
const hasScoringComment = computed(() => {
    return Boolean(String(scoringDisplay.value.comment || "").trim());
});

const approvalUser = computed(() => {
    const approvalId = getApprovalIdForTask(props.task, companyUsers.value || []);
    if (!approvalId) return null;

    const user = getUser(approvalId);
    return user?.ghostUser ? null : user;
});

const isCurrentApprovalUser = computed(() => {
    return isSameId(getApprovalIdForTask(props.task, companyUsers.value || []), userId.value);
});

watch(
    () => props.task?.statusType,
    (newType, oldType) => {
        if (newType === "done" && oldType === "active" && props.task.isKpi && props.task.kpiStatus === "confirmed") {
            confirmKpi({ silent: true });
        }
    },
);

watch(
    () => props.task?._id,
    () => {
        if (props.task?.isKpi) {
            loadKpiScoreData();
        }
    },
    { immediate: true },
);
watch(
    () => props.task?._id,
    (taskId) => {
        if (!taskId) return;
        store.dispatch("ChangeRequest/fetchChangeRequests", {
            taskId,
            companyId: project.value.CompanyId,
        });
    },
    { immediate: true },
);
async function rejectKpi() {
    if (!canReviewKpiTask.value) {
        showKpiPermissionError(t("Kpi.only_approval_can_reject"));
        return;
    }

    try {
        kpiLoading.value = true;

        await unmarkTaskKpi();

        $toast.success(t("Kpi.kpi_rejected"));
    } catch (error) {
        console.error(error);

        $toast.error(t("Kpi.reject_failed"));
    } finally {
        kpiLoading.value = false;
    }
}
async function confirmKpi({ silent = false } = {}) {
    if (!canReviewKpiTask.value) {
        showKpiPermissionError(t("Kpi.only_approval_can_confirm"), { silent });
        return;
    }

    try {
        kpiLoading.value = true;
        const userData = getUserData();
        const firebaseObj = {
            kpiConfirmedAt: new Date(),
            kpiConfirmedBy: userId.value,
        };
        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };

        await taskClass.updateKpiConfirm({
            firebaseObj,
            projectData,
            taskData: props.task,
            userData,
        });

        $toast.success(t("Kpi.kpi_confirmed"), { position: "top-right" });
    } catch (error) {
        console.error("confirmKpi error:", error);

        $toast.error(t("Kpi.confirm_failed"), { position: "top-right" });
    } finally {
        kpiLoading.value = false;
    }
}

async function loadKpiScoreData() {
    try {
        const response = await apiRequest("get", `/api/v1/kpi-tasks/by-task/${props.task._id}`, null, null, {
            params: { companyId: project.value.CompanyId },
        });

        if (response.status && response.data?.data) {
            const data = response.data.data;

            kpiTimeScore.value = Number(data.timeScore ?? 0);
            kpiQualityScore.value = Number(data.qualityScore ?? 0);
            kpiBonus.value = Number(data.bonusScore ?? 0);
            kpiTotalScore.value = Number(data.totalKpiScore ?? 0);
            comment.value = data.kpiReviewComment || "";
            scoringUpdatedAt.value = data.updatedAt || data.reviewedAt || data.createdAt || null;
            showScoringResults.value = true;
            return data;
        }

        showScoringResults.value = false;
        scoringUpdatedAt.value = null;
        return null;
    } catch (error) {
        console.error("ERROR loadKpiScoreData:", error);
        showScoringResults.value = false;
        return null;
    }
}

async function handleKpiToggle(newVal) {
    kpiErrors.value = [];
    if (newVal) {
        if (!canToggleKpi.value) {
            isKpiEnabled.value = false;
            showKpiPermissionError(t("Kpi.only_assignee_or_approval_can_turn_on"));
            return;
        }
        await markTaskAsKpi();
    } else {
        if (props.task?.isKpi && !canEditKpiTask.value) {
            isKpiEnabled.value = true;
            showKpiPermissionError();
            return;
        }
        await unmarkTaskKpi();
    }
}

async function markTaskAsKpi() {
    const errors = [];
    if (!canToggleKpi.value) {
        errors.push(t("Kpi.only_assignee_or_approval_can_turn_on"));
    }
    if (!props.task.TaskName?.trim()) errors.push(t("Kpi.title_required"));
    if (!props.task.description && !props.task.rawDescription && !props.task.descriptionBlock) {
        errors.push(t("Kpi.description_required"));
    }
    if (!props.task.startDate) errors.push(t("Kpi.start_date_required"));
    if (!props.task.DueDate) errors.push(t("Kpi.due_date_required"));
    if (!props.task.AssigneeUserId || props.task.AssigneeUserId.length === 0) {
        errors.push(t("Kpi.assignee_required"));
    }
    if (props.task.AssigneeUserId && props.task.AssigneeUserId.length > 1) {
        errors.push(t("Kpi.only_one_assignee"));
    }
    if (!props.task.Task_Leader) {
        errors.push(t("Kpi.reporter_required"));
    }
    if (!approvalUser.value) {
        errors.push(kpiApprovalMessage.value);
    }

    if (errors.length > 0) {
        kpiErrors.value = errors;
        isKpiEnabled.value = false;
        return;
    }

    kpiLoading.value = true;
    try {
        const userData = getUserData();
        const role = _getRole();
        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };
        await taskClass.updateKpiFlag({
            projectData,
            taskData: props.task,
            userData,
            turnOn: true,
            role,
        });
        if (props.task?.status?.type === "close" && canReviewKpiTask.value) {
            isShowTaskScoringDialog.value = true;
        }
        const statusMsg = role === "manager" ? t("Kpi.marked_auto_confirmed") : t("Kpi.waiting");
        $toast.success(statusMsg, { position: "top-right" });
    } catch (error) {
        console.error("ERROR markAsKpi:", error);
        isKpiEnabled.value = false;
        if (error.validationErrors?.length) {
            kpiErrors.value = error.validationErrors;
        } else {
            $toast.error(error.error || t("Kpi.cannot_mark"), { position: "top-right" });
        }
    } finally {
        kpiLoading.value = false;
    }
}

async function unmarkTaskKpi() {
    if (props.task?.isKpi && !canEditKpiTask.value) {
        showKpiPermissionError();
        return;
    }

    kpiLoading.value = true;
    kpiWaiting.value = false;
    try {
        const userData = getUserData();
        const role = _getRole();

        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };

        await taskClass.updateKpiFlag({
            projectData,
            taskData: props.task,
            userData,
            turnOn: false,
            role,
        });

        $toast.success(t("Kpi.kpi_unmarked"), { position: "top-right" });
    } catch (error) {
        console.error("ERROR unmarkKpi:", error);
        isKpiEnabled.value = true;
        $toast.error(error.error || t("Kpi.cannot_unmark"), { position: "top-right" });
    } finally {
        kpiLoading.value = false;
    }
}

async function onScoringSubmitted(scoringData) {
    try {
        if (!props.task?._id) {
            $toast.error(t("Kpi.invalid_task"));
            return;
        }
        if (!canReviewKpiTask.value) {
            showKpiPermissionError(t("Kpi.only_approval_can_score"));
            return;
        }

        kpiLoading.value = true;
        if (Number(scoringData.qualityScore) < 45) {
            scoringData.bonusScore = 0;
        }
        const payload = {
            qualityScore: scoringData.qualityScore,
            kpiReviewComment: scoringData.comment || "",
            approvalUserId: userId.value,
            companyId: project.value?.CompanyId,
            bonusScore: scoringData.bonusScore,
        };

        await apiRequest("put", `/api/v1/kpi-tasks/review-by-task/${props.task._id}`, payload);

        const data = await loadKpiScoreData();

        if (data) {
            kpiTimeScore.value = Number(data.timeScore ?? 0);
            kpiQualityScore.value = Number(data.qualityScore ?? 0);
            kpiBonus.value = Number(data.bonusScore ?? 0);
            kpiTotalScore.value = Number(data.totalKpiScore ?? 0);
            showScoringResults.value = true;
        }
        if (pendingStatusChange.value) {
            await performStatusUpdate(pendingStatusChange.value.oldVal, pendingStatusChange.value.newval);
            pendingStatusChange.value = null;
        }
        $toast.success(t("Kpi.scored_successfully"));
        isShowTaskScoringDialog.value = false;
    } catch (err) {
        console.error(err);
        $toast.error(t("Kpi.submit_failed"));
    } finally {
        kpiLoading.value = false;
    }
}

const permittedOptions = computed(() => {
    let users = [];
    if (sprintData.value) {
        if (props.task.isParentTask) {
            if (sprintData.value?.private) {
                users = sprintData.value?.AssigneeUserId || [];
            } else {
                if (project.value?.isPrivateSpace) {
                    users = project.value?.AssigneeUserId || [];
                } else {
                    users = companyUsers.value?.map((x) => x.userId);
                }
            }
        } else {
            if (sprintData.value?.private) {
                users = (props.parentTask?.AssigneeUserId || []).filter((x) => sprintData.value?.AssigneeUserId?.includes(x));
            } else {
                users = props.parentTask?.AssigneeUserId || [];
            }
        }
    }
    if (project.value?.isPrivateSpace) {
        users = users.filter((x) => project.value?.AssigneeUserId.includes(x));
        return Array.from(new Set([...users, ...(props.task?.AssigneeUserId || [])]));
    } else {
        return users;
    }
});
const nonPermittedOptions = computed(() => {
    let users = [];
    if (sprintData.value) {
        if (props.task.isParentTask) {
            if (sprintData.value?.private) {
                users = (sprintData.value?.AssigneeUserId || []).filter((x) => x === userId.value);
            } else {
                if (project.value?.isPrivateSpace) {
                    users = (project.value?.AssigneeUserId || []).filter((x) => x === userId.value);
                } else {
                    users = [userId.value];
                }
            }
        } else {
            users = (props.parentTask?.AssigneeUserId || [])?.filter((x) => x === userId.value);
            if (sprintData.value?.private) {
                users = users.filter((x) => sprintData.value?.AssigneeUserId?.includes(x));
            }
        }
    }
    if (project.value?.isPrivateSpace) {
        users = users.filter((x) => project.value?.AssigneeUserId.includes(x));
        return users;
    } else {
        return users;
    }
});

function getUserData() {
    const user = getUser(userId.value);
    return {
        id: user.id,
        Employee_Name: user.Employee_Name,
        companyOwnerId: companyOwner.value.userId,
    };
}

const updateAssignee = async (event, type, { source = "manual" } = {}) => {
    try {
        const currentAssignees = props.task.AssigneeUserId || [];
        const selectedUserId = event.id;
        if (source === "manual" && props.task?.isKpi && !canEditKpiTask.value) {
            showKpiPermissionError();
            return;
        }

        // KPI task: chỉ cho 1 assignee, nếu chọn user khác thì auto replace
        if (props.task.isKpi) {
            if (type === "add") {
                if (currentAssignees.length === 0) {
                    type = "add";
                } else if (currentAssignees.length === 1) {
                    if (currentAssignees[0] === selectedUserId) {
                        return;
                    }
                    type = "replace";
                } else {
                    type = "replace";
                }
            }
        }

        const assignee = getUser(selectedUserId);
        const approvalId = type === "remove" ? null : getApprovalIdForAssignee(selectedUserId, companyUsers.value || []);

        if (props.task.isKpi && type !== "remove" && !approvalId) {
            $toast.error(kpiApprovalMessage.value, {
                position: "top-right",
            });
            return;
        }

        const role = _getRole();
        const isKpiTask = props.task?.isKpi;

        if (source === "manual" && isKpiTask && role === "member") {
            await apiRequest("post", env.TASK_CHANGE_REQUESTS, {
                taskId: props.task._id,
                field: "assignee",
                oldValue: props.task.AssigneeUserId,
                newValue: selectedUserId,
                requestedBy: userId.value,
                companyId: project.value.CompanyId,
            });

            await store.dispatch("ChangeRequest/fetchChangeRequests", {
                companyId: project.value.CompanyId,
                taskId: props.task._id,
            });

            $toast.success(t("Kpi.assignee_change_request_sent"));
            return;
        }

        if (assigneeInProgress.value[selectedUserId] && assigneeInProgress.value[selectedUserId] === type) return;
        assigneeInProgress.value[selectedUserId] = type;

        const userData = getUserData();

        let operation = "";

        if (type === "add") {
            operation = "assigneeAdd";
        } else if (type === "remove") {
            operation = "assigneRemove";
        } else if (type === "replace") {
            operation = "replace";
        }

        const updateObject = {
            AssigneeUserId: selectedUserId,
            approvalUserId: approvalId,
        };

        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };

        taskClass
            .updateAssignee({
                firebaseObj: updateObject,
                projectData,
                taskData: props.task,
                employeeName: assignee?.Employee_Name || "",
                type: operation,
                userData,
            })
            .then(() => {
                delete assigneeInProgress.value[selectedUserId];

                let toastKey = t("Kpi.assignee_added_successfully");
                if (type === "remove") toastKey = t("Kpi.assignee_removed_successfully");
                if (type === "replace") toastKey = t("Kpi.assignee_replaced_successfully");

                $toast.success(toastKey, {
                    position: "top-right",
                });
            })
            .catch((error) => {
                delete assigneeInProgress.value[selectedUserId];
                console.error("ERROR in updateAssignee: ", error);
                $toast.error(t("Toast.Assignee_not_updated"), { position: "top-right" });
            });
    } catch (error) {
        console.error(error);
        $toast.error(t("Toast.Assignee_not_updated"), { position: "top-right" });
    }
};

const updatePriority = async (val) => {
    try {
        if (props.task?.isKpi && !canEditKpiTask.value) {
            showKpiPermissionError();
            return;
        }

        const userData = getUserData();

        let updateObj = {
            Task_Priority: val.value,
        };

        let projectData = {
            _id: project.value._id ? project.value._id : "",
            ProjectName: project.value.ProjectName,
            CompanyId: project.value.CompanyId,
        };

        const priority = getPriority(props.task.Task_Priority);

        let priorityObj = {
            statusImage: await getWasabiImageLink(project.value.CompanyId, priority.image),
            priorityName: priority.name,
            taskId: props.task._id,
            taskName: props.task.TaskName,
            userName: userData.Employee_Name,
            newStatusImage: await getWasabiImageLink(project.value.CompanyId, val.statusImage),
            newPriorityName: val.name,
        };

        taskClass
            .updatePriority({ firebaseObj: updateObj, projectData: projectData, taskData: props.task, priorityObj, userData })
            .then(() => {
                $toast.success(t("Toast.Priority_updated_successfully"), { position: "top-right" });
            })
            .catch((error) => {
                console.error("ERROR in update priority: ", error);
                $toast.error(t("Toast.Priority_not_updated"), { position: "top-right" });
            });
    } catch (error) {
        console.error("updatePriority error", error);
        $toast.error(t("Toast.Priority_not_updated"), { position: "top-right" });
    }
};
const pendingStatusChange = ref(null);
const updateStatus = async (oldVal, newval) => {
    try {
        if (props.task?.isKpi && !canEditKpiTask.value) {
            showKpiPermissionError();
            return;
        }

        if (newval.type == "close" && props.task.isKpi && !props.task.kpiConfirmedAt) {
            $toast.error(t("Kpi.waiting_manager_cannot_close"), { position: "top-right" });
            return;
        }
        const role = _getRole();

        if (newval.type === "done" && props.task.isKpi && role === "member") {
            await performStatusUpdate(oldVal, newval);
            await apiRequest("post", env.TASK_CHANGE_REQUESTS, {
                taskId: props.task._id,
                field: "status",
                oldValue: oldVal,
                newValue: newval,
                requestedBy: userId.value,
                companyId: project.value.CompanyId,
                projectId: project.value._id,
            });
            await store.dispatch("ChangeRequest/fetchChangeRequests", {
                companyId: project.value.CompanyId,
                taskId: props.task._id,
            });
            return;
        }

        if (newval.type == "close" && props.task.isKpi && props.task.kpiConfirmedAt && role === "member") {
            $toast.error(t("Kpi.only_managers_can_close"), { position: "top-right" });
            return;
        }

        if (newval.type == "close" && props.task.isKpi && props.task.kpiConfirmedAt) {
            if (!canReviewKpiTask.value) {
                showKpiPermissionError(t("Kpi.only_approval_can_close_score"));
                return;
            }
            pendingStatusChange.value = { oldVal, newval };
            isShowTaskScoringDialog.value = true;
            return;
        }

        await performStatusUpdate(oldVal, newval);
    } catch (error) {
        console.error("updateStatus error", error);
        $toast.error(t("Toast.Status_not_updated"), { position: "top-right" });
    }
};

const performStatusUpdate = async (oldVal, newval) => {
    try {
        const userData = getUserData();

        const prev = {
            backColor: oldVal.bgColor,
            color: oldVal.textColor,
            statusName: oldVal.name,
        };

        const updatedStatus = {
            text: newval.name,
            key: newval.key,
            type: newval.type,
            value: newval.value,
        };

        const doneStatusTypes = ['done', 'complete', 'completed', 'close', 'closed'];
        const newStatus = {
            status: updatedStatus,
            statusType: newval.type,
            statusKey: newval.key,
            ...(doneStatusTypes.includes(newval.type) ? { statusDoneAt: new Date() } : { statusDoneAt: null }),
        };

        let prevStatus = {
            ...prev,
            taskName: props.task.TaskName,
            bgColor: newval.bgColor,
            textColor: newval.textColor,
            taskId: props.task._id,
            updatedTaskName: newval.name,
        };

        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };

        await taskClass.updateStatus({
            newStatus,
            prevStatus,
            projectData,
            task: props.task,
            userData,
        });

        $toast.success(t("Toast.Status_updated_successfully"), {
            position: "top-right",
        });
    } catch (error) {
        console.error("updateStatus error", error);
        $toast.error(t("Toast.Status_not_updated"), {
            position: "top-right",
        });
        throw error;
    }
};
const isTaskCompleted = computed(() => {
    return props.task?.status.type === "close" && props.task?.isKpi;
});
const normalizeDateOnly = (date) => {
    if (!date) return null;

    let d = date;

    // Firestore timestamp
    if (date?.seconds) {
        d = new Date(date.seconds * 1000);
    } else {
        d = new Date(date);
    }

    if (isNaN(d.getTime())) return null;

    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

const formatDateOnly = (date) => {
    const normalized = normalizeDateOnly(date);
    if (!normalized) return "";

    const day = String(normalized.getDate()).padStart(2, "0");
    const month = String(normalized.getMonth() + 1).padStart(2, "0");
    const year = normalized.getFullYear();

    return `${day}/${month}/${year}`;
};

const validateDateBeforeRequest = ({ field, newValue }) => {
    const newDate = normalizeDateOnly(newValue);

    if (!newDate) return null;

    let currentStart = props.task?.startDate;
    let currentDue = props.task?.DueDate || props.task?.dueDate;

    const latestStartReq = getLatestRequest("start_date");
    const latestDueReq = getLatestRequest("due_date");

    if (latestStartReq?.status === 0) {
        currentStart = latestStartReq.newValue;
    }

    if (latestDueReq?.status === 0) {
        currentDue = latestDueReq.newValue;
    }

    const startDate = normalizeDateOnly(currentStart);
    const dueDate = normalizeDateOnly(currentDue);

    if (field === "start_date" && dueDate && newDate > dueDate) {
        return t("Kpi.start_date_must_be_before_due_date", {
            start: formatDateOnly(newDate),
            due: formatDateOnly(dueDate),
        });
    }

    if (field === "due_date" && startDate && newDate < startDate) {
        return t("Kpi.due_date_must_be_after_start_date", {
            due: formatDateOnly(newDate),
            start: formatDateOnly(startDate),
        });
    }

    return null;
};
const updateDueDate = async (event, { source = "manual" } = {}) => {
    const oldDueDate = localDueDate.value;
    const newDueDate = event.dateVal;

    try {
        if (source === "manual" && props.task?.isKpi && !canEditKpiTask.value) {
            localDueDate.value = oldDueDate;
            dueDateKey.value++;
            showKpiPermissionError();
            return;
        }

        isSpinner.value = true;

        const role = _getRole();
        const userData = getUserData();
        const isKpiTask = props.task?.isKpi;
        const errorMsg = validateDateBeforeRequest({
            field: "due_date",
            newValue: newDueDate,
        });

        if (errorMsg) {
            localDueDate.value = oldDueDate;
            dueDateKey.value++;
            $toast.error(errorMsg, { position: "top-right" });
            return;
        }

        if (source === "manual" && isKpiTask && role === "member") {
            await apiRequest("post", env.TASK_CHANGE_REQUESTS, {
                taskId: props.task._id,
                field: "due_date",
                oldValue: oldDueDate,
                newValue: newDueDate,
                requestedBy: userId.value,
                companyId: project.value.CompanyId,
            });

            await store.dispatch("ChangeRequest/fetchChangeRequests", {
                companyId: project.value.CompanyId,
                taskId: props.task._id,
            });

            $toast.success(t("Kpi.due_date_change_request_sent"));
            return;
        }

        // 👉 Optimistic UI
        localDueDate.value = newDueDate;

        let newDueDateDeadLine = [];

        if (props.task?.dueDateDeadLine?.length) {
            newDueDateDeadLine = props.task.dueDateDeadLine.map((d) => ({
                date: new Date(d.date),
            }));
        }

        if (source !== "approve") {
            newDueDateDeadLine.push({ date: new Date(newDueDate) });
        }

        const updateobj = {
            DueDate: newDueDate,
            dueDateDeadLine: newDueDateDeadLine,
        };

        let notificationObj = {
            key: "task_due_date",
            projectId: props.task.ProjectID,
            taskId: props.task._id,
            sprintId: props.task.sprintId,
        };

        let obj = {
            ProjectName: project.value.ProjectName,
            TaskName: props.task.TaskName,
        };

        if (props.task?.dueDate) {
            obj.previousDate = changeDateFormate(new Date(props.task.dueDate.seconds * 1000));
            obj.changedDate = changeDateFormate(newDueDate);
            notificationObj.message = taskDueDateChange(obj);
        } else {
            obj.lastDate = changeDateFormate(newDueDate);
            notificationObj.message = taskDueDateAdd(obj);
        }

        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };

        await taskClass.updateDueDate({
            commonDateFormatString: dateFormat.value,
            firebaseObj: updateobj,
            project: projectData,
            task: props.task,
            obj: notificationObj,
            userData,
        });

        $toast.success(t("Toast.Due_date_updated_successfully"), {
            position: "top-right",
        });
    } catch (error) {
        localDueDate.value = oldDueDate; // ✅ rollback thật
        dueDateKey.value++; // force re-render to reset date picker

        console.error(error);
        $toast.error(error?.error?.response?.data?.statusText || error?.response?.data?.statusText || t("Toast.Due_date_not_updated"), {
            position: "top-right",
        });
    } finally {
        isSpinner.value = false;
    }
};

const updateStartDate = async (event, { source = "manual" } = {}) => {
    const oldDate = localStartDate.value;
    const newDate = event.dateVal;

    try {
        if (source === "manual" && props.task?.isKpi && !canEditKpiTask.value) {
            localStartDate.value = oldDate;
            startDateKey.value++;
            showKpiPermissionError();
            return;
        }

        const role = _getRole();
        const isKpiTask = props.task?.isKpi;

        // 🔥 KPI + member → validate trước khi gửi request
        if (source === "manual" && isKpiTask && role === "member") {
            const errorMsg = validateDateBeforeRequest({
                field: "start_date",
                newValue: newDate,
            });

            if (errorMsg) {
                localStartDate.value = oldDate; // rollback UI
                startDateKey.value++; // force re-render to reset date picker
                $toast.error(errorMsg, { position: "top-right" });
                return;
            }

            await apiRequest("post", env.TASK_CHANGE_REQUESTS, {
                taskId: props.task._id,
                field: "start_date",
                oldValue: oldDate,
                newValue: newDate,
                requestedBy: userId.value,
                companyId: project.value.CompanyId,
            });

            await store.dispatch("ChangeRequest/fetchChangeRequests", {
                companyId: project.value.CompanyId,
                taskId: props.task._id,
            });

            $toast.success(t("Kpi.start_date_change_request_sent"));
            return;
        }

        const errorMsg = validateDateBeforeRequest({
            field: "start_date",
            newValue: newDate,
        });

        if (errorMsg) {
            localStartDate.value = oldDate; // rollback UI
            startDateKey.value++; // force re-render to reset date picker
            $toast.error(errorMsg, { position: "top-right" });
            return;
        }

        // 👉 Optimistic UI
        localStartDate.value = newDate;

        const userData = getUserData();

        const updateobj = {
            startDate: newDate,
        };

        let notificationObj = {
            key: "task_due_date",
            projectId: props.task.ProjectID,
            taskId: props.task._id,
            sprintId: props.task.sprintId,
        };

        let obj = {
            ProjectName: project.value.ProjectName,
            TaskName: props.task.TaskName,
        };

        if (props.task?.startDate) {
            obj.previousDate = changeDateFormate(new Date(props.task.startDate.seconds * 1000));
            obj.changedDate = changeDateFormate(newDate);
            notificationObj.message = taskDueDateChange(obj);
        } else {
            obj.lastDate = changeDateFormate(newDate);
            notificationObj.message = taskDueDateAdd(obj);
        }

        const projectData = {
            _id: project.value._id,
            CompanyId: project.value.CompanyId,
            lastTaskId: project.value.lastTaskId,
            ProjectName: project.value.ProjectName,
            ProjectCode: project.value.ProjectCode,
        };

        await taskClass.updateStartDate({
            commonDateFormatString: dateFormat.value,
            firebaseObj: updateobj,
            project: projectData,
            task: props.task,
            obj: notificationObj,
            userData,
        });

        $toast.success(t("Toast.Start_date_updated_successfully"), {
            position: "top-right",
        });
    } catch (error) {
        localStartDate.value = oldDate; // ✅ rollback thật
        startDateKey.value++; // force re-render to reset date picker

        console.error("ERROR in updateStartDate: ", error);
        $toast.error(error?.error?.response?.data?.statusText || error?.response?.data?.statusText || t("Toast.Start_date_not_updated"), {
            position: "top-right",
        });
    }
};
</script>
<style scoped src="./style.css"></style>

<style scoped>
.w-full {
    width: 100%;
}
.kpi-toggle-wrapper {
    gap: 8px;
}

.kpi-status-badge {
    font-size: 11px;
    font-weight: 500;
    padding: 2px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.kpi-badge-pending {
    background-color: #fef3c7;
    color: #d97706;
}

.kpi-badge-confirmed {
    background: #dcfce7;
    color: #008236;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.kpi-badge-rejected {
    background-color: #fee2e2;
    color: #dc2626;
}

.kpi-badge-expired {
    background-color: #f3f4f6;
    color: #6b7280;
}

.notify-manager-note {
    min-height: 26px;
    padding: 0 10px;
    border: 1px solid #fde68a;
    border-radius: 7px;
    background-color: #fffbeb;
    color: #b45309;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
}

.kpi-review-actions {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-left: 8px;
    white-space: nowrap;
}

.kpi-review-actions .kpi-badge-waiting,
.kpi-review-actions .kpi-badge-confirmed {
    min-height: 26px;
    padding: 0 10px;
    border-radius: 7px;
    display: inline-flex;
    align-items: center;
}

.kpi-review-button {
    min-width: 64px;
    height: 26px;
    padding: 0 11px;
    border-radius: 7px;
    font-size: 11px;
    font-weight: 600;
    line-height: 24px;
    transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.kpi-review-button.outline-green:hover {
    color: #ffffff;
    background-color: #16a34a;
    box-shadow: 0 2px 6px rgba(22, 163, 74, 0.18);
}

.kpi-review-button.outline-red:hover {
    color: #ffffff;
    background-color: #ef4444;
    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.18);
}

.kpi-errors-wrapper {
    padding: 6px 12px;
    margin: 0 12px 8px;
    background-color: #fef2f2;
    border-radius: 6px;
    border: 1px solid #fecaca;
}

.kpi-error-item {
    font-size: 12px;
    color: #dc2626;
    line-height: 1.4;
    padding: 1px 0;
}

.kpi-score-value {
    font-size: 14px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 4px;
}

.kpi-score-green {
    background-color: #d1fae5;
    color: #059669;
}

.kpi-score-yellow {
    background-color: #fef3c7;
    color: #d97706;
}

.kpi-score-red {
    background-color: #fee2e2;
    color: #dc2626;
}

.kpi-waiting-tag {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background-color: #fff7ed;
    border: 1px solid #fdba74;
    border-radius: 6px;
    animation: kpi-pulse 2s ease-in-out infinite;
}

.kpi-waiting-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #f97316;
    animation: kpi-blink 1.5s ease-in-out infinite;
}

.kpi-waiting-text {
    font-size: 12px;
    font-weight: 600;
    color: #ea580c;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.kpi-waiting-sub {
    font-size: 11px;
    font-weight: 400;
    color: #9a3412;
}

.kpi-waiting-review {
    background-color: #eff6ff;
    border-color: #93c5fd;
}

.kpi-waiting-review .kpi-waiting-dot {
    background-color: #3b82f6;
}

.kpi-waiting-review .kpi-waiting-text {
    color: #1d4ed8;
}

.kpi-waiting-review .kpi-waiting-sub {
    color: #1e40af;
}

.kpi-late-info {
    font-size: 12px;
    color: #dc2626;
    margin-left: 6px;
}
.old-date-text {
    font-size: 11px;
    color: #9ca3af; /* xám nhẹ */
    margin-top: 2px;
    font-style: italic;
    padding-left: 8.5px;
}
@keyframes kpi-blink {
    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }
}

@keyframes kpi-pulse {
    0%,
    100% {
        border-color: #fdba74;
    }

    50% {
        border-color: #fb923c;
    }
}

.kpi-loading {
    display: flex;
    align-items: center;
}

.spin-animation {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
